import React from "react";
interface Props {
  className?: string;
}
function LeftArrowAccordian({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //   width="11"
      //   height="14"
      className={className}
      fill="none"
      viewBox="0 0 26 22"
    >
      <path
        fill="#262626"
        d="M11.148 21.523a.563.563 0 000-.796l-9.165-9.164h23.392a.563.563 0 000-1.125H1.983l9.165-9.165a.562.562 0 10-.796-.796L.227 10.602a.563.563 0 000 .796l10.125 10.125a.562.562 0 00.796 0z"
      ></path>
    </svg>
  );
}

export default LeftArrowAccordian;
